import React from 'react'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { Variant } from '@mui/material/styles/createTypography'
import { toTitleCase } from './functions'

type TypographyProps = {
  children: any
  variant?: Variant
  // | 'button'
  // | 'caption'
  // | 'h1'
  // | 'h2'
  // | 'h3'
  // | 'h4'
  // | 'h5'
  // | 'h6'
  // | 'inherit'
  // | 'subtitle1'
  // | 'subtitle2'
  // | 'body1'
  // | 'body2'
  // | 'overline'
  // | 'srOnly'
  // | undefined
  className?: string
  style?: {
    [key: string]: string | number
  }
}

export const T: React.FC<TypographyProps> = ({
  children,
  variant,
  style,
  ...props
}) => (
  <Typography {...props} style={style} variant={variant || 'body2'}>
    {children}
  </Typography>
)
export const LI: React.FC<TypographyProps> = ({ children, variant }) => (
  <li>
    <T style={{ marginBottom: 0 }} variant={variant}>
      {children}
    </T>
  </li>
)
export const OL: React.FC<TypographyProps> = ({ children, variant }) => (
  <ol>
    <T variant={variant}>{children}</T>
  </ol>
)
export const O: React.FC<TypographyProps> = ({ children }) => (
  <span style={{ color: '#d9559d' }}>{children}</span>
)

type RProps = {
  category?: string
  value: string
  anchor?: string
  noYour?: boolean
}

export const R: React.FC<RProps> = ({ category, anchor, value, noYour }) => {
  const categoryText = toTitleCase(category?.replaceAll('_', ' ') ?? '')
  const valueText = value
    ? toTitleCase(
        value
          .replaceAll('_', ' ')
          .replaceAll(' nonfiction', '')
          .replaceAll(' fiction', ''),
      )
    : ''
  return (
    <T
      style={{
        margin: 0,
        textAlign: 'center',
        fontSize: 18,
        fontFamily: 'Poppins',
      }}>
      <b>
        {noYour ? '' : 'Your '}
        {categoryText}
        {category !== undefined ? ': ' : null}
        {anchor ? <Link href={`#${anchor}`}>{valueText}</Link> : valueText}
      </b>
    </T>
  )
}

export const summaryText = ({ category, feature }): string => {
  const categoryText = toTitleCase(category?.replaceAll('_', ' ') ?? '')
  const featureText = toTitleCase(feature?.replaceAll('_', ' ') ?? '')
  return `Your ${categoryText}${
    category !== undefined ? ': ' : null
  }${featureText}`
}
